import { Injectable } from '@angular/core';

import { FavoriteService, AppContext, Carrier, Vessel, Port } from './../../shared';
declare const moment: any;

@Injectable()
export class MyFavoritesService {

  constructor(private favoriteService: FavoriteService, public app: AppContext) {
  }

  getStartDate(): string {
    let now = moment();

    return encodeURIComponent(now.format('YYYY-MM-DD'));
  }

  getEndDate(): string {
    let now = moment();

    return encodeURIComponent(now.add(1, 'week').format('YYYY-MM-DD'));
  }

  getCarriers(): Array<Carrier> {
    let carriers = new Array<Carrier>();

    try {
      return this.app.carriers;
    } catch (ex) {
      return carriers;
    }
  }

  getPorts(): Array<Port> {
    let ports = new Array<Port>();

    try {
      return this.app.ports;
    } catch (ex) {
      return ports;
    }
  }

  getVessels(): Array<Vessel> {
    let vessels = new Array<Vessel>();

    try {
      return this.app.vessels;
    } catch (ex) {
      return vessels;
    }
  }

  getRoutes(): Array<any> {
    let routes = new Array<any>();

    try {
      return this.app.routes;
    } catch (ex) {
      return routes;
    }
  }

  callUnFavoriteRoute(originId: number, destinationId: number) {
    return this.favoriteService.unfavoriteRoute(originId, destinationId);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/my-favorites/my-favorites.service.ts